var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workspace-specific-info-card" },
    [
      _c("tabs", {
        attrs: {
          tabs: _vm.tabs,
          "active-tab": _vm.activeTab,
          "tabs-styling": _vm.tabsStyling,
          "tabs-labels-styling": _vm.tabsLabelsStyling,
          "center-tabs": false
        },
        on: {
          startTabChange: function($event) {
            _vm.activeTab = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "users"
        ? _c(
            "div",
            { style: { height: "calc(100% - 80px)", "margin-top": "21px" } },
            [
              _c("Table", {
                attrs: {
                  checkbox: false,
                  tableLines: true,
                  loading: _vm.loading,
                  headers: _vm.usersHeaders,
                  items: _vm.users,
                  "add-row-button": false,
                  "action-buttons": false
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "companies"
        ? _c(
            "div",
            { style: { height: "calc(100% - 80px)", "margin-top": "21px" } },
            [
              _c("Table", {
                attrs: {
                  checkbox: false,
                  tableLines: true,
                  loading: _vm.loading,
                  headers: _vm.companiesHeaders,
                  items: _vm.companies,
                  "add-row-button": false,
                  "action-buttons": false
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "map"
        ? _c(
            "div",
            { style: { height: "calc(100% - 80px)" } },
            [
              _c("management-map", {
                style: { height: "calc(100% - 40px)" },
                attrs: {
                  geo_json: _vm.textGeom,
                  drawable: _vm.editing,
                  showZoomButtons: true,
                  showCenterMapButton: true,
                  showRestartButton: _vm.editing,
                  showUploadGeomFromFileButton: _vm.editing,
                  showCoordinatesButton: _vm.editing
                },
                on: {
                  "update-map-data": function($event) {
                    return _vm.$emit("update-map-data", $event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd19fade", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd19fade","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Directory/WorkspaceSpecificInfo.vue
// module id = null
// module chunks = 